/**
 * API Single Source File
 *
 * Example Usage:
 *  import api from "[path_to_this_file]/api",
 *  const result = await api.function(xx);
 *  console.log(result);
 */
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import firebase from "firebase/app";
import "firebase/auth";

const apiHostUrlDirectly = "https://engjob.kmutt.ac.th/api";
// const apiHostUrlDirectly = "http://10.2.14.129/api";

const apiHostInternal = "";

const apiUrl = {
  directAPI: `${apiHostUrlDirectly}`,
  internalAPI: `${apiHostInternal}`
};

async function apiRequest(url, method, path, data, params, headers = {}) {
  return axios
    .request({
      method,
      url: `${url}/${path}`,
      data,
      params,
      headers
    })
  // TODO add catch here if neeeded
}

// eslint-disable-next-line no-unused-vars
function getReq(type, path, params) {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    // "Content-Type": "application/x-www-form-urlencoded"
  }
  return apiRequest(apiUrl[type], "get", path, undefined, params, headers);
}

// eslint-disable-next-line no-unused-vars
function getReqAuth(auth, type, path, params) {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Authorization": `Bearer ${auth}`
    // "Content-Type": "application/x-www-form-urlencoded"
  }
  return apiRequest(apiUrl[type], "get", path, undefined, params, headers);
}

// eslint-disable-next-line no-unused-vars
function delReq(type, path, data, params) {
  return apiRequest(apiUrl[type], "delete", path, data, params);
}

function postReq(type, path, data, params) {

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  };
  return apiRequest(apiUrl[type], "post", path, data, params, headers);
}

function postReqAuth(auth, type, path, data, params) {

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "Authorization": `Bearer ${auth}`
  };
  return apiRequest(apiUrl[type], "post", path, data, params, headers);
}

// eslint-disable-next-line no-unused-vars
function putReqAuth(auth, type, path, data, params) {

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "Authorization": `Bearer ${auth}`
  };
  return apiRequest(apiUrl[type], "put", path, data, params, headers);
}

// eslint-disable-next-line no-unused-vars
function postFormReq(type, path, data, params) {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/x-www-form-urlencoded"
  };
  return apiRequest(apiUrl[type], "post", path, data, params, headers);
}


export default {
  // demo
  // chartOptionsFullField: (requestBody) => postReq("directAPI", `analytic/graphAllDataFullField`, requestBody),

  // Company Auth
  registerData: (requestHead, requestBody) => postReqAuth(requestHead, "directAPI", `company/add-company-data`, requestBody),
  getCompanyDetial: (requestHead, requestBody) => postReqAuth(requestHead, "directAPI", `company/get-company`, requestBody),
  updateCompanyDetail: (requestHead, requestBody) => putReqAuth(requestHead, "directAPI", `company/edit-company-data`, requestBody),
  getAllCompanyDetail: () => getReq("directAPI", `kmutt/get-approve-company`),

  // Auth
  checkToken: (requestHead) => getReqAuth(requestHead, "directAPI", 'kmutt/check-token'),

  // Kmutt Auth
  kmuttLogin: (requestBody) => postReq("directAPI", `kmutt/login`, requestBody),
  getKmuttDetail: (requestHead) => getReqAuth(requestHead, "directAPI", `kmutt/get-Kmutt`),
  sendKmuttDetail: (requestHead, requestBody) => putReqAuth(requestHead, "directAPI", `kmutt/edit-student`, requestBody),

  // Staff Auth
  getCompanyDetailForStaff: (requestHead) => getReqAuth(requestHead, "directAPI", `kmutt/get-all`),
  changeStatusCompany: (requestHead, requestBody) => postReqAuth(requestHead, "directAPI", `kmutt/staff-approve-company`, requestBody),
  // changeStatusCompany: (requestHead, requestBody) => postReqAuth(requestHead, "directAPI", `kmutt/company-approve`, requestBody),

  // Data Register
  getProvinceJson: () => getReq("internalAPI", `data/allProvince.json`),
  getCityJson: () => getReq("internalAPI", `data/allCity.json`),

  // NEW Public
  getAllJobs: () => getReq("directAPI", `kmutt/get-approve-job`),

}
